export const COLLISION_00: string = "collision-00";
export const COLLISION_01: string = "collision-01";
export const COLLISION_02: string = "collision-02";
export const COLLISION: string[] = [ COLLISION_00, COLLISION_01, COLLISION_02 ];
export const COLLISION_GROUND: string = "collision-ground";
export const CONGRATULATIONS: string = "congratulations";
export const GO_UP: string = "go-up";
export const LOSE_00: string = "lose-00";
export const LOSE_01: string = "lose-01";
export const LOSE: string[] = [ LOSE_00, LOSE_01 ];
export const NEXT: string = "next";
export const ONBOARDING_AVOID: string = "onboarding-avoid";
export const ONBOARDING_FREEPLAY: string = "onboarding-freeplay";
export const ONBOARDING_HIT: string = "onboarding-hit";
export const ONBOARDING_POWERUP: string = "onboarding-powerup";
export const ONBOARDING_TICKET: string = "onboarding-ticket";
export const ONBOARDING_UP: string = "onboarding-up";
export const PLAY: string = "play";
export const POWERUP_HEALTH: string = "powerup-health";
export const POWERUP_SHIELD: string = "powerup-shield";
export const POWERUP_SHRINK: string = "powerup-shrink";
export const POWERUP_SPEED_00: string = "powerup-speed-00";
export const POWERUP_SPEED_01: string = "powerup-speed-01";
export const SELECT_HOVER_PREFIX: string = "select-hover-";
export const SELECT_IDLE_00: string = "select-idle-00";
export const SELECT_IDLE_01: string = "select-idle-01";
export const SELECT_IDLE: string[] = [ SELECT_IDLE_00, SELECT_IDLE_01 ];
export const SELECT_NEW_00: string = "select-new-00";
export const SELECT_NEW_01: string = "select-new-01";
export const SELECT_NEW_02: string = "select-new-02";
export const SELECT_NEW: string[] = [ SELECT_NEW_00, SELECT_NEW_01, SELECT_NEW_02 ];
export const SELECT_UNLOCK_PREFIX: string = "select-unlock-";
export const TICKET_COLLECT_00: string = "ticket-collection-00";
export const TICKET_COLLECT_01: string = "ticket-collection-01";
export const TICKET_COLLECT: string[] = [ TICKET_COLLECT_00, TICKET_COLLECT_01 ];
export const TITLE: string = "title";
export const TRY_AGAIN: string = "try-again";
export const LEVEL_START_PREFIX: string = "welcome-";
export const WIN_PREFIX: string = "win-";
export const WIN_GENERIC: string = "win-generic";
export const WIN_CIRCUS: string = "win-circus";

export const FF_GEN_PREFIX: string = "ff-gen-";
export const FF_GEN_COUNT: number[] =  [ 3, 3, 3, 2, 2, 3, 4, 4 ];
export const FF_CHI_BEIHEI: string = "ff-lm-chi-beihai";
export const FF_CHI_BELL: string = "ff-lm-chi-bell";
export const FF_CHI_DRUM: string = "ff-lm-chi-drum";
export const FF_EGY_OBELISK: string = "ff-lm-egy-obelisk";
export const FF_EGY_OPERA: string = "ff-lm-egy-opera";
export const FF_EGY_SPHINX: string = "ff-lm-egy-sphinx";
export const FF_ENG_BIGBEN: string = "ff-lm-eng-bigben";
export const FF_ENG_BRIDGE: string = "ff-lm-eng-bridge";
export const FF_ENG_EYE: string = "ff-lm-eng-eye";
export const FF_ENG_TOWER: string = "ff-lm-eng-tower";
export const FF_IND_JAMAMASJID: string = "ff-lm-ind-jamamasjid";
export const FF_IND_JANTARMANTAR: string = "ff-lm-ind-jantarmantar";
export const FF_IND_LODHI: string = "ff-lm-ind-lodhi";
export const FF_JAP_SUMO: string = "ff-lm-jap-sumo";
export const FF_JAP_YOYOGI: string = "ff-lm-jap-yoyogi";
export const FF_MEX_ANGEL: string = "ff-lm-mex-angel";
export const FF_MEX_ZOCALOS: string = "ff-lm-mex-zocalos";
export const FF_RUS_BOLSHOI: string = "ff-lm-rus-bolshoi";
export const FF_RUS_CATHEDRAL: string = "ff-lm-rus-cathedral";
export const FF_RUS_REDSQUARE: string = "ff-lm-rus-redsquare";
export const FF_RUS_SPACE: string = "ff-lm-rus-space";

// The order of this array must match the RegionType enum in Regions.ts
export const REGION_SUFFIX: string[] = [
    "mex",
    "rus",
    "egy",
    "chi",
    "eng",
    "ind",
    "aus",
    "jap",
];
